module.exports = __webpack_public_path__ + "img/solution20.061040eb.png";